// extracted by mini-css-extract-plugin
export var climateNav = "climateNav-module--climateNav--BeDp0";
export var navDivider = "climateNav-module--navDivider--3JODa";
export var navSelected = "climateNav-module--navSelected--YjKJ4";
export var slideUp = "climateNav-module--slideUp--m9aS2";
export var slideUpLarge = "climateNav-module--slideUpLarge--kT3Mr";